Vue.mixin({
  computed: {
    user() {
      return window.user
    }
  },
  methods: {
    requiresAuth(text, intended) {

      if (!_.isString(text)) {
        text = 'Pro provedení této akce je potřeba být přihlášen.'
      }

      if (intended === 'current') {
        intended = location.pathname
      }

      this.$swal({
        title: '',
        text: text,
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'Přihlásit',
        cancelButtonText: 'Zpět'
      }).then((result) => {
        if (result.value) {
          window.location.href = '/login' +
            (intended ? `?intended=${intended}` : '')
        }
      })
    },
    moment(date) {
      return moment(date)
    },
    trans(text) {
      return text
    }
  }
})
